import React from 'react';
import { printables } from 'Settings/printables';

import styles from './GamePrintable.scss';
import Icon from './printable.svg';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

const GamePrintable = ({ id }) => {
  const printable = printables[id];

  const downloadUri = `/assets/printables/${printable.printableFileName}`;

  return (
    <div className="GamePrintable">
      <Icon className="GamePrintable__icon" />
      <a href={downloadUri} className="GamePrintable__link" target="_blank">
        <ConnectedFormattedMessage id={`printables.${id}.title`} />
      </a>
    </div>
  );
};

export default GamePrintable;
